import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/errors";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      nav("/challenges");
    } catch (err) {
      setError(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <div className="label-mono mb-3">Join</div>
      <h1 className="font-display font-black uppercase text-4xl tracking-tighter mb-8">Create account</h1>
      <form onSubmit={onSubmit} className="card p-8 space-y-4">
        <div>
          <label className="label-mono block mb-2">Display name</label>
          <input className="input" value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name-input" />
        </div>
        <div>
          <label className="label-mono block mb-2">Email</label>
          <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email-input" />
        </div>
        <div>
          <label className="label-mono block mb-2">Password</label>
          <input className="input" type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="register-password-input" />
        </div>
        {error && <div className="tag tag-wrong block" data-testid="register-error">{error}</div>}
        <button className="btn btn-primary w-full" disabled={loading} data-testid="register-submit-button">
          {loading ? "Creating…" : "Create account"}
        </button>
        <div className="label-mono text-center pt-2" style={{ color: "var(--text-dim)" }}>
          Have an account? <Link to="/login" className="underline" data-testid="register-to-login-link">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
